import { loadable } from '../shared/utils';

const adminRouters = [
    {
        path: '/module-list',
        component: loadable(() => import('../modules/module/ModuleList'))
    },
    
]
export { adminRouters };